import { useState } from "react"
import { useAppDispatch } from "../../app/hooks"
import { closePopup } from "../../app/popup-slice"
import styles from "./info-quality-dialog.module.css"
import { HTMLInfoDivideBySpecificText, HTMLInfoDivideHalf } from "../../util/format-html-content"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/free-solid-svg-icons"
import DirectionButton from "../directionButton/direction-button"
import { translatedTag } from "../../util/msg-by-stage-and-tag"
import { useMessages2 } from "../../hooks/useLanguage"

export const InfoQualityDialog = ({
  materialInfo,
}: {
  materialInfo?: Record<string, string>
}) => {
    const dispatch = useAppDispatch()
    const [isTechnicalInfo, setIsTechnicalInfo] = useState(true)
    const { messages } = useMessages2();

    const onHandleStepButton = () => {
        setIsTechnicalInfo(!isTechnicalInfo)
    }

    const handleClose = () => {
        dispatch(closePopup())
    }

    let result: string[] = []

    if(materialInfo?.technical){
        if(materialInfo.tags[0] === 'fabric'){
            result = HTMLInfoDivideBySpecificText(materialInfo?.technical || "", messages!.care_cleaning);
            if(result.length === 0) {
                result = HTMLInfoDivideHalf(materialInfo?.technical);
            }
        } else {
            result = HTMLInfoDivideHalf(materialInfo?.technical);
        }
    }

    return (
        <div className={styles.dialogContainer}>
        
            <div className={styles.topContent}>
                <div className={styles.title}>
                    <h3>{translatedTag(materialInfo?.tags[0], messages)}</h3>
                    <h1>{materialInfo?.name}</h1>
                </div>

                <FontAwesomeIcon
                    icon={faXmark}
                    className={styles.closeButton}
                    onClick={handleClose}
                />
            </div>

            <div className={`${styles.content}`}>   
                
                <div className={`${styles.infoContainer} ${isTechnicalInfo ? styles.slideIn : styles.slideOut}`}>
                    <div className={styles.textInfo}>
                        {materialInfo?.general && <div className={styles.general} dangerouslySetInnerHTML={{ __html: materialInfo?.general}}/>}
                        {result.length > 0 && 
                        <>
                            <h2 className={styles.technicalSpecTitle}>{messages!.technical_specifications}</h2>
                            <div className={styles.technical} dangerouslySetInnerHTML={{ __html: result ? result[0] : "" }}/>
                            <div className={styles.technical} dangerouslySetInnerHTML={{ __html: result ? result[1] : "" }}/> 
                        </>}
                    </div>

                    { materialInfo?.maintenance && <div className={styles.directButton} onClick={onHandleStepButton}>             
                        <DirectionButton type='invert' onClick={onHandleStepButton} text={messages?.care_instructions}/>
                    </div> }

                </div>
                
                { materialInfo?.maintenance && 
                    <div className={`${styles.infoContainer} ${isTechnicalInfo ? styles.slideOut2 : styles.slideIn}`}>
                        <div className={styles.textInfo}>
                            <div className={styles.maitenance} dangerouslySetInnerHTML={{ __html: materialInfo?.maintenance || "" }}/>
                        </div>
                        <div className={styles.directButton} onClick={onHandleStepButton}>             
                            <DirectionButton type='prev' onClick={onHandleStepButton} text={messages?.intro_terug_button}/>
                        </div>
                    </div> 
                }

            </div>

        </div>
    )
}
